import { render, staticRenderFns } from "./CompProfileSkeletonTopInformation.vue?vue&type=template&id=6301cff2&scoped=true"
import script from "./CompProfileSkeletonTopInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileSkeletonTopInformation.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6301cff2",
  null
  
)

export default component.exports